// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage } from "firebase/storage";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDhtpBF3eT2ll81KsfsSK_oQ63F-H_Tgi8",
  authDomain: "prmassist-marketplace.firebaseapp.com",
  projectId: "prmassist-marketplace",
  storageBucket: "prmassist-marketplace.firebasestorage.app",
  messagingSenderId: "4067604199",
  appId: "1:4067604199:web:928b2a19a09348e2115442",
  measurementId: "G-H1DTJVSJC4"
};

try {
    firebase.initializeApp(firebaseConfig, "marketplace");
    //firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

const fire = firebase;
export default fire;

// Initialize Firebase
const app = initializeApp(firebaseConfig, "marketplace");
export {app}
export const storage = getStorage(app);
const firestore = getFirestore(app);
export {firestore}
const analytics = getAnalytics(app);


